import { FC, useMemo, useCallback } from 'react';
import { API } from '@brg/api';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import {
  LongreadBlockWrapper,
  CaptionBlockWrapper,
} from '../../styles/LongreadBlockRenderer.styles';
import {
  ProductsWrapper,
  ProductsList,
  ProductCard,
  ProductImage,
  ProductTitle,
  ProductPrice,
} from '../../styles/LongreadBlockRenderer.styles';
import { useProductsCards } from '../../../CardSelectModal/ProductsSelectModal';
import { FormatLinkedText } from 'brg-longread';
import { Endpoints } from '@brg/api';

interface ProductsBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ProductsBlock: FC<ProductsBlockProps> = ({ block, backgroundColor }) => {
  const { i18n } = useTranslation();
  const cardIds = useMemo(() => block.cardIds || [], [block.cardIds]);
  const requestsDisabled = !cardIds?.length;
  

  const cardsQueryString = useMemo(() => {
    return queryString.stringify({
      cardOnlyImage: true,
      status: [2],
      cardIds,
      isHeaderIgnored: true,
      isLite: 'true',
      limit: 50
    });
  }, [cardIds]);

  const { data, loading } = useProductsCards(cardsQueryString, requestsDisabled);

  const cardsSorted = useMemo(() => {
    if (cardIds?.length && data?.data) {
      const sortingIndex = cardIds.reduce(
        (acc: any, cardId: string, index: number) => {
          return {
            ...acc,
            [cardId]: index
          };
        },
        {}
      );

      const cards = API.lang(data.data, i18n.language);
      const sorted = [...cards].sort((a: any, b: any) => {
        if (sortingIndex[a.entityId] > sortingIndex[b.entityId]) {
          return 1;
        }
        if (sortingIndex[a.entityId] < sortingIndex[b.entityId]) {
          return -1;
        }
        return 0;
      });
      return sorted;
    }
    return [];
  }, [data, cardIds, i18n.language]);

  const defaultTextColor = '#FEFEFE'; 

  const handleCardClick = useCallback((cardId: string) => {
    const shopUrl = process.env.REACT_APP_URL_SHOP_BRANDS || '';
    if (shopUrl) {
      window.open(`${shopUrl}/card/${cardId}`, '_blank');
    }
  }, []);

  if (loading) {
    return (
      <LongreadBlockWrapper>
        <ProductsWrapper style={{ backgroundColor: '#151514' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            Загрузка...
          </div>
        </ProductsWrapper>
      </LongreadBlockWrapper>
    );
  }

  if (!cardsSorted?.length) {
    return null;
  }

  return (
    <LongreadBlockWrapper>
      <ProductsWrapper style={{ backgroundColor: '#151514' }}>
        <ProductsList>
          {cardsSorted.map((card: any) => {
            const cardLang = API.toLang(card, i18n.language);
            //@ts-ignore
            const cardName = cardLang?.templateData?.title || cardLang?.templateType?.name || card?.name || '';
            const cardImage = card?.images?.[0]?.url 
              ? `${Endpoints.files}/${card.images[0].url}` 
              : null;
            const price = card?.price || 0;

            return (
              <ProductCard 
                key={card.entityId}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick(card.entityId);
                }}
              >
                <ProductImage>
                  {card?.templateType?.nameComponent ? (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {cardImage && <img src={cardImage} alt={cardName} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                    </div>
                  ) : (
                    cardImage && <img src={cardImage} alt={cardName} />
                  )}
                </ProductImage>
                {cardName && <ProductTitle>{cardName}</ProductTitle>}
                <ProductPrice textColor={defaultTextColor}>{price} ₽</ProductPrice>
              </ProductCard>
            );
          })}
        </ProductsList>
        {block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </ProductsWrapper>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo, useCallback } from 'react';
import { API } from '@brg/api';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import {
  LongreadBlockWrapper,
  CaptionBlockWrapper,
} from '../../styles/LongreadBlockRenderer.styles';
import {
  ProductsWrapper,
  ProductsList,
  ProductCard,
  ProductImage,
  ProductTitle,
  ProductPrice,
} from '../../styles/LongreadBlockRenderer.styles';
import { useProductsCards } from '../../../CardSelectModal/ProductsSelectModal';
import { FormatLinkedText } from 'brg-longread';
import { Endpoints } from '@brg/api';

interface ProductsBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ProductsBlock: FC<ProductsBlockProps> = ({ block, backgroundColor }) => {
  const { i18n } = useTranslation();
  const cardIds = useMemo(() => block.cardIds || [], [block.cardIds]);
  const requestsDisabled = !cardIds?.length;
  

  const cardsQueryString = useMemo(() => {
    return queryString.stringify({
      cardOnlyImage: true,
      status: [2],
      cardIds,
      isHeaderIgnored: true,
      isLite: 'true',
      limit: 50
    });
  }, [cardIds]);

  const { data, loading } = useProductsCards(cardsQueryString, requestsDisabled);

  const cardsSorted = useMemo(() => {
    if (cardIds?.length && data?.data) {
      const sortingIndex = cardIds.reduce(
        (acc: any, cardId: string, index: number) => {
          return {
            ...acc,
            [cardId]: index
          };
        },
        {}
      );

      const cards = API.lang(data.data, i18n.language);
      const sorted = [...cards].sort((a: any, b: any) => {
        if (sortingIndex[a.entityId] > sortingIndex[b.entityId]) {
          return 1;
        }
        if (sortingIndex[a.entityId] < sortingIndex[b.entityId]) {
          return -1;
        }
        return 0;
      });
      return sorted;
    }
    return [];
  }, [data, cardIds, i18n.language]);

  const defaultTextColor = '#FEFEFE'; 

  const handleCardClick = useCallback((cardId: string) => {
    const shopUrl = process.env.REACT_APP_URL_SHOP_BRANDS || '';
    if (shopUrl) {
      window.open(`${shopUrl}/card/${cardId}`, '_blank');
    }
  }, []);

  if (loading) {
    return (
      <LongreadBlockWrapper>
        <ProductsWrapper style={{ backgroundColor: '#151514' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            Загрузка...
          </div>
        </ProductsWrapper>
      </LongreadBlockWrapper>
    );
  }

  if (!cardsSorted?.length) {
    return null;
  }

  return (
    <LongreadBlockWrapper>
      <ProductsWrapper style={{ backgroundColor: '#151514' }}>
        <ProductsList>
          {cardsSorted.map((card: any) => {
            const cardLang = API.toLang(card, i18n.language);
            //@ts-ignore
            const cardName = cardLang?.templateData?.title || cardLang?.templateType?.name || card?.name || '';
            const cardImage = card?.images?.[0]?.url 
              ? `${Endpoints.files}/${card.images[0].url}` 
              : null;
            const price = card?.price || 0;

            return (
              <ProductCard 
                key={card.entityId}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick(card.entityId);
                }}
              >
                <ProductImage>
                  {card?.templateType?.nameComponent ? (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {cardImage && <img src={cardImage} alt={cardName} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                    </div>
                  ) : (
                    cardImage && <img src={cardImage} alt={cardName} />
                  )}
                </ProductImage>
                {cardName && <ProductTitle>{cardName}</ProductTitle>}
                <ProductPrice textColor={defaultTextColor}>{price} ₽</ProductPrice>
              </ProductCard>
            );
          })}
        </ProductsList>
        {block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </ProductsWrapper>
    </LongreadBlockWrapper>
  );
};
